import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Chip,
  Box,
  Typography,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import EmailIcon from '@mui/icons-material/Email';
import BadgeIcon from '@mui/icons-material/Badge';

export default function TUsuarios({ rows, seleccionar, termp, isModal = false }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  function searchingTermp(termp) {
    return function (x) {
      const nombrecompleto = x.nombrecompleto || '';
      const alias = x.userName || '';
      const email = x.email || '';
      const numusuario = x.numusuario || '';

      return (
        nombrecompleto.toLowerCase().includes(termp.toLowerCase()) ||
        alias.toLowerCase().includes(termp.toLowerCase()) ||
        email.toLowerCase().includes(termp.toLowerCase()) ||
        numusuario.toLowerCase().includes(termp.toLowerCase()) ||
        !termp
      );
    };
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const filteredRows = (rows || []).filter(searchingTermp(termp));
  const paginatedRows = filteredRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Usuario
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Alias
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  backgroundColor: '#e3f2fd',
                  color: 'primary.main',
                  fontSize: '0.875rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  borderBottom: 2,
                  borderColor: 'primary.main',
                }}
              >
                Número
              </TableCell>
              {/* {!isModal && ( */}
                <TableCell
                  align="center"
                  sx={{
                    fontWeight: 700,
                    backgroundColor: '#e3f2fd',
                    color: 'primary.main',
                    fontSize: '0.875rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  Acciones
                </TableCell>
              {/* )} */}
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.length > 0 ? (
              paginatedRows.map((usuario) => (
                <TableRow
                  key={usuario.id}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                    transition: 'background-color 0.2s ease',
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <PersonIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      <Typography variant="body2" fontWeight={500}>
                        {usuario.nombrecompleto}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={usuario.userName}
                      size="small"
                      icon={<BadgeIcon />}
                      variant="outlined"
                      color="primary"
                      sx={{ fontWeight: 500 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <EmailIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
                      <Typography variant="body2">{usuario.email}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" fontFamily="monospace" fontWeight={500}>
                      {usuario.numusuario}
                    </Typography>
                  </TableCell>
                  {!isModal && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<SettingsIcon />}
                        onClick={() => seleccionar(usuario)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: 1.5,
                          px: 2,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Administrar
                      </Button>
                    </TableCell>
                  )}
                  {isModal && (
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => seleccionar(usuario)}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: 1.5,
                          px: 2,
                          boxShadow: 1,
                          '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-1px)',
                          },
                          transition: 'all 0.2s ease',
                        }}
                      >
                        Seleccionar
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 8 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2,
                      color: 'text.secondary',
                    }}
                  >
                    <PersonIcon sx={{ fontSize: 64, opacity: 0.3 }} />
                    <Typography variant="h6">
                      No se encontraron usuarios
                    </Typography>
                    <Typography variant="body2">
                      {termp
                        ? 'Intenta con otros términos de búsqueda'
                        : 'Aún no hay usuarios registrados'}
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={filteredRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`
        }
        sx={{
          borderTop: 1,
          borderColor: 'divider',
          '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
            fontWeight: 500,
          },
        }}
      />
    </Box>
  );
}
